import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'counter',
    component: () => import('../views/Counter')
  },
  // {
  //   path: '/',
  //   name: 'home',
  //   component: Home
  // },
  {
    path: '/pages',
    component: () => import('../views/Pages/Base.vue'),
    children: [
      { 
        path: 'about',
        name: 'about',
        meta: {name: 'Sobre'},
        component: () => import('../views/About')
      },
      { 
        path: 'contact',
        name: 'contact',
        meta: {name: 'Contato'},
        component: () => import('../views/Contact')
      },
      { 
        path: 'termos-de-uso-e-servico',
        name: 'termosDeUsoEServico',
        meta: {name: 'Termos de uso e serviço'},
        component: () => import('../views/Terms/TermosDeUsoEServico')
      },
      { 
        path: 'politica-de-privacidade',
        name: 'politicaDePrivacidade',
        meta: {name: 'Política de privacidade'},
        component: () => import('../views/Terms/PoliticaDePrivacidade')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
